
import React from 'react'
import {Input}from "antd"
import three_img from "../../../../images/config/authorizationProgress/3.png"
import four_img from "../../../../images/config/authorizationProgress/4.png"
import five_img from "../../../../images/config/authorizationProgress/5.png"
import enterpriseId from "../../../../images/config/authorizationProgress/enterpriseId.png"
import developerInterface from "../../../../images/config/authorizationProgress/developerInterface.png"
import enterpriseTrustedIp from "../../../../images/config/authorizationProgress/enterpriseTrustedIp.png"
import Message from "../../../common/message";
import CorpApi from "../../../public/corp_api";
class AuthorizationSubmit extends React.Component {
    constructor(props){
        super(props);
        this.agentIdChange=this.agentIdChange.bind(this);
        this.secretChange=this.secretChange.bind(this);
        this.enterpriseId=this.enterpriseId.bind(this);
        this.state={
            agentId:'',
            secret:'',
            corpId:'',
        }
    }
    componentDidMount() {
        CorpApi.getGainSubmitSeltBulidUseMessage((data)=>{
            this.setState({
                agentId:data.agentId,
                secret:data.secret,
                corpId:data.corpId
            })
        },()=>{
            Message.error('获取失败')
        })
    }

    agentIdChange(e){
        this.setState({
            agentId:e.target.value
        })
    }
    secretChange(e){
        this.setState({
            secret:e.target.value
        })
    }
    enterpriseId(e){
        this.setState({
            corpId:e.target.value
        })
    }
    checkData(){
        if((!this.state.agentId) || this.state.agentId.length == 0){
            Message.warning("请输入AhentId", null, null, true);
        }
        if((!this.state.secret) || this.state.secret.length == 0){
            Message.warning("请输入Secret", null, null, true);
        }
        if((!this.state.corpId) || this.state.corpId.length == 0){
            Message.warning("请输入企业ID", null, null, true);
        }
    }
    /**
     * 整合改组件数据并返回
     */
    getData() {
        let data = {
            agentId:this.state.agentId,
            secret:this.state.secret,
            corpId: this.state.corpId
        };
        return data
    }
    render() {
        return (
            <div className={'authorizationSubmit'}>
                <div>
                    <div>1. 创建成功后，在创建的【紫鲲】内找到Secret和Agentld,复制并填写到下方</div>
                    <div className={'authorization_Input_Change'}>
                        <span>*AgenyId：</span>
                        <span><Input size='smallz' placeholder="请输入AhentId" value={this.state.agentId} onChange={this.agentIdChange}/></span>
                    </div>
                    <div className={'authorization_Input_Change'}>
                        <span>*Secret：</span>
                        <span><Input size='smallz' placeholder="请输入Secret" value={this.state.secret} onChange={this.secretChange}/></span>
                    </div>
                    <div>（1）Agentld 复制操作路径：应用管理—自建—紫鲲应用—Agentld后面的参数值，复制粘贴到输入框中</div>
                    <div><img src={three_img}/></div>
                    <div>（2）Secret 复制操作路径：应用管理—自建—紫鲲应用—Secret—查看—发送</div>
                    <div><img src={four_img}/></div>
                    <div>发送成功后，管理员会在企业微信中将会收到如下提醒，复制粘贴到到输入框中</div>
                    <div><img src={five_img}/></div>
                    <div>2. 创建成功后，在创建的【紫鲲】应用里面找到企业可信IP，点击配置，然后将下方的两个IP填写到可信IP里面并保存。（注意IP地址以英文“;”分割）</div>
                    <div>39.106.134.71;39.105.47.156</div>
                    <div style={{width:'800px'}}><img style={{width:'100%'}} src={developerInterface}/></div>
                    <div style={{width:'800px'}}><img style={{width:'100%'}} src={enterpriseTrustedIp}/></div>
                    <div>3. 在【我的企业】内找到企业ID，复制并填写到下方</div>
                    <div className={'authorization_Input_Change'}>
                        <span>*企业ID：</span>
                        <span><Input size='smallz' placeholder="请输入企业ID" value={this.state.corpId} onChange={this.enterpriseId}/></span>
                    </div>
                    <div>企业ID 复制操作路径：我的企业—企业ID后面的参数值，复制粘贴到输入框中</div>
                    <div><img src={enterpriseId}/></div>
                </div>
            </div>
        )
    }
}

export default AuthorizationSubmit
